import React, { forwardRef } from 'react';
import CaretLeftIcon from '../../../../components/Icons/CaretLeftIcon';
import './DragCarousel.scss';

const LEFT_ARROW = 'left_arrow';
const RIGHT_ARROW = 'right_arrow';

const DragCarousel = (props, ref) => {
  const {
    childrens,
    activeIndicator,
    gap,
    arrows,
    indicators,
    handleIndicatorClick,
    indicatorCount,
    handleArrowClick,
  } = props;

  const { sliderRef, leftArrowRef, rightArrowRef } = ref || {};

  const className = 'c-DragCarouselContainer-DragCarousel';
  const arrowsClassName = `${className}__arrow${arrows ? '' : '--hidden'}`;
  const indicatorsClassName = `${className}__indicator${
    indicators ? '' : '--hidden'
  }`;

  const renderIndicator = (index) => {
    const classNames = `${className}__indicator__item${
      index === activeIndicator ? '--active' : ''
    }`;
    return (
      <div
        className={classNames}
        key={index}
        onClick={() => handleIndicatorClick(index)}
      ></div>
    );
  };

  return (
    <div className={className}>
      <div className={`${className}__wrapper`}>
        <div
          className={`${className}__carousel`}
          ref={sliderRef}
          style={{ gap: `${gap}px` }}
        >
          {childrens}
        </div>
        <div
          ref={leftArrowRef}
          className={`${arrowsClassName} ${className}__arrow--left`}
          onClick={() => handleArrowClick(LEFT_ARROW)}
        >
          <CaretLeftIcon />
        </div>
        <div
          ref={rightArrowRef}
          className={`${arrowsClassName} ${className}__arrow--right`}
          onClick={() => handleArrowClick(RIGHT_ARROW)}
        >
          <CaretLeftIcon />
        </div>
      </div>
      <div className={`${indicatorsClassName}`}>
        {Array(indicatorCount)
          .fill({})
          .map((_, index) => renderIndicator(index))}
      </div>
    </div>
  );
};

export default forwardRef(DragCarousel);
